import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import banner from "../../../assets/images/PartBD/Medicare Banner-what you need to know_2.png";
import { BiChevronsRight } from "react-icons/bi";
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const MedicationPartD = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <Container>
      <TopServiceBanner title=" Med Part B & D" banner={banner} />
      <Inner>
        <Title>How to get prescription drug coverage</Title>
        <SubTitle>
          Medicare drug coverage helps pay for prescription drugs you need. Even
          if you don’t take prescription drugs now, you should consider getting
          Medicare drug coverage. Medicare drug coverage is optional and is
          offered to everyone with Medicare. If you decide not to get it when
          you’re first eligible, and you don’t have other creditable
          prescription drug coverage (like drug coverage from an employer or
          union) or get Extra Help, you’ll likely pay a late enrollment penalty
          if you join a plan later. Generally, you’ll pay this penalty for as
          long as you have Medicare drug coverage. To get Medicare drug
          coverage, you must join a Medicare-approved plan that offers drug
          coverage. Each plan can vary in cost and specific drugs covered.
        </SubTitle>
        <Title>There are 2 ways to get Medicare drug coverage:</Title>
        <SubTitle>
          1. Medicare drug plans. These plans add drug coverage to Original
          Medicare, some Medicare Cost Plans, some Private Fee‑for‑Service
          plans, and Medical Savings Account plans. You must have Medicare Part
          A (Hospital Insurance) and/or Medicare Part B (Medical Insurance) to
          join a separate Medicare drug plan.
          <br />
          <br />
          2. Medicare Advantage Plan (Part C) or other Medicare Health Plan with
          drug coverage. You get all of your Part A, Part B, and drug coverage,
          through these plans. Remember, you must have Part A and Part B to join
          a Medicare Advantage Plan, and not all of these plans offer drug
          coverage.
          <br />
          <br />
          To join a Medicare drug plan, Medicare Advantage Plan, or other
          Medicare health plan with drug coverage, you must be a United States
          citizen or lawfully present in the United States.
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>How to join a drug plan</MiddleTextLeft>
              <MiddleSubTitle>
                Once you choose a Medicare drug plan, here's how to get
                prescription drug coverage:
              </MiddleSubTitle>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  Enroll on the Medicare Plan Finder or on the plan's website.
                </Li>
                <Li>
                  <BiChevronsRight />
                  Complete a paper enrollment form.
                </Li>
                <Li>
                  <BiChevronsRight />
                  Call the plan.
                </Li>
                <Li>
                  <BiChevronsRight />
                  Call us at 1-800-MEDICARE (1-800-633-4227). TTY:
                  1-877-486-2048.
                </Li>
              </Ul>
              <br />
              <MiddleSubTitle>
                When you join a Medicare drug plan, you'll give your Medicare
                Number and the date your Part A and/or Part B coverage started.
                This information is on your Medicare card.
              </MiddleSubTitle>
            </MiddleInnerLeft>
            {/* <MiddleInnerRight>
          <Img src={img} alt="ALF" />
        </MiddleInnerRight> */}
          </MiddleInner>
        </Middle>

        <Title>Consider all your drug coverage choices</Title>
        <SubTitle>
          Before you make a decision, learn how prescription drug coverage works
          with your other drug coverage. For example, you may have drug coverage
          from an employer or union, TRICARE, the Department of Veterans Affairs
          (VA), the Indian Health Service, or a Medicare Supplement Insurance
          (Medigap) policy. Compare your current coverage to Medicare drug
          coverage. The drug coverage you already have may change because of
          Medicare drug coverage, so consider all your coverage options.
          <br />
          <br />
          If you have (or are eligible for) other types of drug coverage, read
          all the materials you get from your insurer or plan provider. Talk to
          your benefits administrator, insurer, or plan provider before you make
          any changes to your current coverage.
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>
                Joining a Medicare drug plan may affect your Medicare Advantage
                Plan{" "}
              </MiddleTextLeft>
              <MiddleSubTitle>
                If you join a Medicare Advantage Plan, you’ll usually get drug
                coverage through that plan. In certain types of plans that can’t
                offer drug coverage (like Medical Savings Account plans) or
                choose not to offer drug coverage (like certain Private
                Fee-for-Service plans), you can join a separate Medicare drug
                plan. If you’re in a Health Maintenance Organization, HMO
                Point-of-Service plan, or Preferred Provider Organization, and
                you join a separate drug plan, you’ll be disenrolled from your
                Medicare Advantage Plan and returned to Original Medicare.
              </MiddleSubTitle>
              <br />
              <MiddleSubTitle>
                You can only join a separate Medicare drug plan without losing
                your current health coverage when you’re in a:
              </MiddleSubTitle>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  Private Fee-for-Service Plan
                </Li>
                <Li>
                  <BiChevronsRight />
                  Medical Savings Account Plan
                </Li>
                <Li>
                  <BiChevronsRight />
                  Cost Plan
                </Li>
                <Li>
                  <BiChevronsRight />
                  Certain employer-sponsored Medicare health plans
                </Li>
              </Ul>
              <br />
              <MiddleSubTitle>
              Talk to your current plan if you have questions about what will happen to your current health coverage.
              </MiddleSubTitle>
            </MiddleInnerLeft>
            {/* <MiddleInnerRight>
          <Img src={img} alt="ALF" />
        </MiddleInnerRight> */}
          </MiddleInner>
        </Middle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />

    </Container>
  );
};

export default MedicationPartD;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 10rem;
  padding-top: 1rem;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 10rem;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const MiddleInnerLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
// const MiddleInnerRight = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;

  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
// const Img = styled.img`
//   width: 100%;
//   height: 100%;

//   @media (max-width: 1180px) {
//     width: 45%;
//     height: 45%;
//     margin-top: 1rem;
//   }
// `;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
